import React, { useState, useEffect } from 'react';
import { ValidCaptcha } from '../../util/varios';
import { Mensaje, MensajeCapcha, MensajeSiNo } from '../mensajes';

import {Dimmer } from '../spinner';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTable from "../useTable";
import axios from 'axios';
import { ActualizarProducto } from './modalActualizarProducto';

const headCells = [
    { id: 'idproducto', label: 'CODIGO', width: '80px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'descripcion', label: 'DESCRIPCION', width: '440px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'accion', label: 'OPCIONES', width: '180px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
]


function TablaProductos(props) {
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [producto, setProducto] = useState();
    const [tipopro, setTipopro] = useState();
    const [tipoproid, setTipoproid] = useState();
    const [unidad, setUnidad] = useState();
    const [unidadid, setUnidadid] = useState();
    const [activate, setActivate] = useState(false);
    const [declaWeb, setDeclaWeb] = useState(false);
    const [datoscuentas, setDatoscuentas] = useState(false);
    const [cuenta, setCuenta] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [idusuario, setIdUsuario] = useState(localStorage.getItem('idusuario'));
    const [ip, setIp] = useState(localStorage.getItem('ip'));
    const [idefiscal, setIdefiscal] = useState(localStorage.getItem('idefiscal'));
    const [mac, setMac] = useState(localStorage.getItem('mac'));

    const [operacion, setOperacion] = useState(0);


    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../src/modulos/datos');


    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idproducto.toLowerCase().includes(target.value.toLowerCase())
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const blanquear = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setProducto();

    }

    //console.log(values)

    const seleccionarRegistros = () => {

        let campos = '*';
        let nomtab = 'producto';
        let orden = 'idproducto';

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setRecords(response.data);
                setActivate(false);
            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const seleccionarRegistro = (idproducto) => {

        let campos = '*';
        let nomtab = 'producto';
        let nomid = 'idproducto';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idproducto}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.idproducto > 0) {
                    setProducto(response.data);
                    seleccionarTipoProducto(response.data.idtipoproducto);
                    seleccionarUnidadMedida(response.data.idunidadmedida);
                }

            }
            setActivate(false)

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar5(true)
            setActivate(false);

        })

    }

    const seleccionarTipoProducto = (idtipoproducto) => {

        let endpoint = `${op.conexion}/api/comprasAlmacen/selecttipoproducto?idtipoproducto=${idtipoproducto}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.idtipoproducto > 0) {
                    setTipoproid(response.data);
                    console.log(response.data)
                    setMostrar5(true);
                }

            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar5(true)
            setActivate(false);

        })

    }

    const seleccionarUnidadMedida = (idunidadmedida) => {

        let endpoint = `${op.conexion}/api/comprasAlmacen/selectunidadmedida?idunidadmedida=${idunidadmedida}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.idunidadmedida > 0) {
                    setUnidadid(response.data);
                    console.log(response.data)
                    setMostrar5(true);
                }

            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar5(true)
            setActivate(false);

        })

    }

    const selectCatgTipopro = () => {

        let endpoint = `${op.conexion}/api/catalogo/tipoproducto`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                setTipopro(response.data);
                setActivate(false);
            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const selectCatgUnidadMedida = () => {

        let endpoint = `${op.conexion}/api/catalogo/unidadmedida`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                setUnidad(response.data);
                setActivate(false);
            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

   

    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }

    const consultarProducto = (ope, id) => (event) => {

        event.preventDefault();
        blanquear();

        if (ope === 1) {

            setMostrar5(true);
            setOperacion(1);

        } else if (ope === 4) {

            setOperacion(4);
            seleccionarRegistro(id);

        } else if (ope === 2) {

            setOperacion(2);
            seleccionarRegistro(id);

        } else if (ope === 3) {

            setOperacion(3);
            seleccionarRegistro(id);

        }
    };

    useEffect(() => {

        seleccionarRegistros();
        selectCatgTipopro();
        selectCatgUnidadMedida();
 
    }, []);


    return (
        <div className="card">
            <ActualizarProducto
                show={mostrar5}
                declaWeb={declaWeb}
                tipoproid={tipoproid ? tipoproid : ''}
                unidadid={unidadid ? unidadid : ''}
                tipopro={tipopro}
                unidad={unidad}
                ip={ip}
                mac={mac}
                producto={producto}
                operacion={operacion}
                onHideRenderizar={seleccionarRegistros}
                onHideCancela={cerrarModalActualizar} />

            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                   />

            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <input className="search-input form-control mr-sm-2" style={{ border: '1px solid #007bff' }} type="search" placeholder="Buscar" onChange={handleSearch} aria-label="Search" />
                                    </div>
                                    <div className="col-md-6"></div>
                                    <div className="col-md-3" style={{fontFamily: 'Times New Roman, Times, serif'}}>
                                        <button onClick={consultarProducto(1, '')} className="btn col-md-12 btn-outline-primary"><i className="fas fa-plus"> Agregar Producto</i> </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idproducto} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "12px", textAlign: "left", border: "rgb(14, 101, 238) 1px solid", width: "80px", fontFamily: 'Times New Roman, Times, serif' }}>{item.idproducto}</td>
                                                    <td style={{ fontSize: "12px", textAlign: "left", border: "rgb(14, 101, 238) 1px solid", width: "60px", fontFamily: 'Times New Roman, Times, serif' }}>{item.descripcion}</td>
                                                    <td className='mx-auto' align="center" style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "180px", padding: 0 }}>
                                                        <button onClick={consultarProducto(4, item.idproducto)} className="btn btn-outline-info py-2"><i className="fas fa-search"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button onClick={consultarProducto(2, item.idproducto)} className="btn  btn-outline-success"><i className="fa fa-edit"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button onClick={consultarProducto(3, item.idproducto)} className="btn  btn-outline-danger"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <TblPagination />

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );

}

export default TablaProductos;
